"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ipBan = require("@/api/ipBan");
var _permission = require("@/utils/permission");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'IpBanRecord',
  data: function data() {
    return {
      listLoading: false,
      tableData: {
        list: [],
        total: 0
      },
      searchForm: {
        ip: '',
        isUnbanned: '',
        dateRange: [],
        page: 1,
        limit: 20
      },
      unbanDialogVisible: false,
      unbanning: false,
      resetCount: false,
      currentRecord: {}
    };
  },
  created: function created() {
    if ((0, _permission.checkPermi)(['platform:ip:ban:record:list'])) this.loadList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    loadList: function loadList() {
      var _this = this;
      this.listLoading = true;
      var params = _objectSpread({}, this.searchForm);
      if (params.isUnbanned === '') delete params.isUnbanned;
      if (params.dateRange && params.dateRange.length === 2) {
        params.startTime = params.dateRange[0];
        params.endTime = params.dateRange[1];
      }
      delete params.dateRange;
      (0, _ipBan.ipBanRecordList)(params).then(function (res) {
        _this.tableData = res;
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.loadList();
    },
    handleReset: function handleReset() {
      this.searchForm = {
        ip: '',
        isUnbanned: '',
        dateRange: [],
        page: 1,
        limit: 20
      };
      this.loadList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.searchForm.limit = val;
      this.loadList();
    },
    handlePageChange: function handlePageChange(page) {
      this.searchForm.page = page;
      this.loadList();
    },
    handleUnban: function handleUnban(row) {
      this.currentRecord = row;
      this.resetCount = false;
      this.unbanDialogVisible = true;
    },
    confirmUnban: function confirmUnban() {
      var _this2 = this;
      this.unbanning = true;
      (0, _ipBan.ipBanRecordUnban)(this.currentRecord.id, this.resetCount).then(function () {
        _this2.$message.success('解封成功');
        _this2.unbanDialogVisible = false;
        _this2.loadList();
      }).finally(function () {
        _this2.unbanning = false;
      });
    },
    formatTtl: function formatTtl(seconds) {
      if (!seconds) return '-';
      if (seconds < 3600) return "".concat(Math.round(seconds / 60), " \u5206\u949F");
      if (seconds < 86400) return "".concat(Math.round(seconds / 3600), " \u5C0F\u65F6");
      return "".concat(Math.round(seconds / 86400), " \u5929");
    }
  }
};